import ExtensionLinkView from './view'

const ExtensionLink = ExtensionLinkView

export default ExtensionLink